import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://utxukfvhswrxdcrfqupv.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV0eHVrZnZoc3dyeGRjcmZxdXB2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODM5MTMyMzMsImV4cCI6MTk5OTQ4OTIzM30.i8hW-PSqZBJxmUgFLC9XZG0fnibiv8QLinpN01qJm50";
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
